// extracted by mini-css-extract-plugin
export var copy = "footer-module--copy--ef52a";
export var created = "footer-module--created--c781f";
export var createdLink = "footer-module--created-link--e90fe";
export var createdLogo = "footer-module--created-logo--ceeb1";
export var footer = "footer-module--footer--79fd7";
export var logo = "footer-module--logo--5645f";
export var nav = "footer-module--nav--c6571";
export var post = "footer-module--post--eb6ce";
export var social = "footer-module--social--dbbf7";
export var socialList = "footer-module--social-list--09441";